import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { IpoApiService } from '@ip-only/front-end-library';
import { KeycloakUser } from '../../hub/entities/user';
import { UserApiPaths } from './user-api.entities';

@Injectable({ providedIn: 'root' })
export class UserApiService implements IpoApiService<KeycloakUser> {
  USERS_BASE_URL_V1 = `${environment.backendBaseUrl}/v1${UserApiPaths.Users}`;

  constructor(private http: HttpClient) {}

  fetchSingle(userId: string) {
    return this.http.get<KeycloakUser>(`${this.USERS_BASE_URL_V1}/${userId}`);
  }
}
